import type {Status} from "../types";
import {getContentDispFilename} from "./getContentDispFilename";

const EXPORT_BASE = "/dibappapi/api/collection/export";

export type Orientation = "portrait" | "landscape";

export const buildChecklistExportUrl = (params: {
    format: "docx" | "xlsx";
    topicId: string;
    collectionId?: string;
    orientation: Orientation;
    vlabels?: string[];
    status?: (string | Status | number)[];
    version?: string;
    template?: string;
}): string => {
    const qs = new URLSearchParams();
    if (params.collectionId) qs.set("collectionId", params.collectionId);
    qs.set("resourceId", params.topicId);
    qs.set("orientation", params.orientation);
    if (params.vlabels?.length) qs.set("vlabels", params.vlabels.join(","));
    if (params.status?.length) qs.set("status", params.status.join(","));
    if (params.version) qs.set("version", params.version);
    if (params.format === "docx")
        qs.set("template", params.template ?? "0");
    return `${EXPORT_BASE}/${params.format}?${qs.toString()}`;
};

export const buildDocumentsExportUrl = (params: {
    format: "docx" | "zip";
    topicId: string;
    collectionId?: string;
    segmentId?: string;
    topics: string[];
    withComments?: boolean;
    version?: string;
    template?: string;
    email?: string;
}): string => {
    const qs = new URLSearchParams();
    qs.set("resourceId", params.topicId);
    if (params.collectionId) qs.set("collectionId", params.collectionId);
    if (params.segmentId) qs.set("segmentId", params.segmentId);
    if (params.topics.length) qs.set("topics", params.topics.join(";"));
    if (params.withComments) qs.set("withComments", "true");
    if (params.version) qs.set("version", params.version);
    if (params.template !== undefined)
        qs.set("template", params.template);
    if (params.email) qs.set("email", params.email);
    return `${EXPORT_BASE}/${params.format}?${qs.toString()}`;
};

export const downloadExport = async (url: string): Promise<void> => {
    const response = await fetch(url, {credentials: "include"});
    if (!response.ok) throw new Error(`Export failed: ${response.status}`);

    const filename =
        getContentDispFilename(
            response.headers.get("Content-Disposition"),
        ) ?? "export";

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(objectUrl);
};

export const sendExportMail = async (url: string): Promise<void> => {
    const response = await fetch(url, {credentials: "include"});
    if (!response.ok) throw new Error(`Send mail failed: ${response.status}`);
};
